(function () {
  const HN_API_URL =
    "https://intranet.microtecinformatique.com";

  class HNAnalytics {
    constructor() {
      this.migrateLegacyStorage();

      this.visitorId =
        this.getVisitorId();

      /* Campagne HN active pour la session courante. */
      this.activeCampaign = null;

      /* Variantes de contenu résolues depuis PostgreSQL/API. */
      this.activeVariants = {
        hero: null,
        promo: null,
        shop_more: null
      };
    }

    /* ============================================================
       COOKIES
    ============================================================ */

    getCookie(name) {
      const prefix =
        `${encodeURIComponent(name)}=`;

      const cookies =
        document.cookie
          .split(";")
          .map(cookie =>
            cookie.trim()
          );

      for (const cookie of cookies) {
        if (cookie.startsWith(prefix)) {
          return decodeURIComponent(
            cookie.substring(
              prefix.length
            )
          );
        }
      }

      return null;
    }

    setCookie(
      name,
      value,
      days = 365
    ) {
      const maxAge =
        days * 24 * 60 * 60;

      const secure =
        window.location.protocol === "https:"
          ? "; Secure"
          : "";

      document.cookie =
        `${encodeURIComponent(name)}=${encodeURIComponent(value)}; ` +
        `Path=/; Max-Age=${maxAge}; SameSite=Lax${secure}`;
    }

    deleteCookie(name) {
      const secure =
        window.location.protocol === "https:"
          ? "; Secure"
          : "";

      document.cookie =
        `${encodeURIComponent(name)}=; ` +
        `Path=/; Max-Age=0; SameSite=Lax${secure}`;
    }

    /* ============================================================
       LEGACY LOCALSTORAGE MIGRATION
    ============================================================ */

    migrateLegacyStorage() {
      try {
        const oldConsent =
          localStorage.getItem(
            "hn_consent_personalization"
          );

        const oldVisitorId =
          localStorage.getItem(
            "hn_visitor_id"
          );

        if (
          !this.getCookie(
            "hn_consent_personalization"
          ) &&
          (
            oldConsent === "true" ||
            oldConsent === "false"
          )
        ) {
          this.setCookie(
            "hn_consent_personalization",
            oldConsent,
            365
          );
        }

        if (
          oldConsent === "true" &&
          oldVisitorId &&
          !this.getCookie(
            "hn_visitor_id"
          )
        ) {
          this.setCookie(
            "hn_visitor_id",
            oldVisitorId,
            365
          );
        }

        localStorage.removeItem(
          "hn_visitor_id"
        );

        localStorage.removeItem(
          "hn_consent_personalization"
        );
      } catch (error) {
        
      }
    }

    /* ============================================================
       VISITOR
    ============================================================ */

    getVisitorId() {
      let visitorId =
        this.getCookie(
          "hn_visitor_id"
        );

      if (
        !visitorId &&
        this.hasPersonalizationConsent()
      ) {
        visitorId =
          crypto.randomUUID();

        this.setCookie(
          "hn_visitor_id",
          visitorId,
          365
        );
      }

      return visitorId;
    }

    /* ============================================================
       CONSENT
    ============================================================ */

    hasPersonalizationConsent() {
      return (
        this.getCookie(
          "hn_consent_personalization"
        ) === "true"
      );
    }

    setPersonalizationConsent(value) {
      if (value === true) {
        this.setCookie(
          "hn_consent_personalization",
          "true",
          365
        );

        this.visitorId =
          this.getCookie(
            "hn_visitor_id"
          ) ||
          crypto.randomUUID();

        this.setCookie(
          "hn_visitor_id",
          this.visitorId,
          365
        );

        

        return Promise.resolve(true);
      }

      return this.rejectPersonalization();
    }

    /* ============================================================
       REJECT / DELETE HN
    ============================================================ */

    async rejectPersonalization() {
      const oldVisitorId =
        this.getCookie(
          "hn_visitor_id"
        ) ||
        this.visitorId;

      this.deleteCookie(
        "hn_visitor_id"
      );

      /* On conserve uniquement le choix "refusé" afin que la
         bannière ne réapparaisse pas après chaque rechargement. */
      this.setCookie(
        "hn_consent_personalization",
        "false",
        365
      );

      try {
        localStorage.removeItem(
          "hn_visitor_id"
        );

        localStorage.removeItem(
          "hn_consent_personalization"
        );
      } catch (error) {
        
      }

      this.clearStoredCampaign();

      this.visitorId = null;

      if (oldVisitorId) {
        try {
          const response = await fetch(
            `${HN_API_URL}/api/privacy/visitor/${encodeURIComponent(oldVisitorId)}`,
            {
              method: "DELETE",
              headers: {
                "ngrok-skip-browser-warning":
                  "true"
              }
            }
          );

          if (!response.ok) {
            throw new Error(
              `HN privacy deletion error: ${response.status}`
            );
          }

          
        } catch (error) {
          
        }
      }

      window.location.reload();
    }

    /* ============================================================
       CAMPAIGNS
    ============================================================ */

    getCampaignSlugFromUrl() {
      try {
        const params =
          new URLSearchParams(
            window.location.search
          );

        const slug =
          params.get(
            "hn_campaign"
          );

        return slug
          ? slug.trim()
          : null;
      } catch (error) {
        return null;
      }
    }

    getStoredCampaignSlug() {
      if (
        !this.hasPersonalizationConsent()
      ) {
        return null;
      }

      try {
        return sessionStorage.getItem(
          "hn_campaign"
        );
      } catch (error) {
        return null;
      }
    }

    storeCampaignSlug(slug) {
      if (
        !slug ||
        !this.hasPersonalizationConsent()
      ) {
        return;
      }

      try {
        sessionStorage.setItem(
          "hn_campaign",
          slug
        );
      } catch (error) {
        // sessionStorage peut être indisponible dans certains navigateurs.
      }
    }

    clearStoredCampaign() {
      try {
        sessionStorage.removeItem(
          "hn_campaign"
        );
      } catch (error) {
        // Rien à faire.
      }

      this.activeCampaign = null;
      this.activeVariants = {
        hero: null,
        promo: null,
        shop_more: null
      };
    }

    async resolveCampaign(slug) {
      if (!slug) {
        return null;
      }

      try {
        const response = await fetch(
          `${HN_API_URL}/api/campaigns/resolve/${encodeURIComponent(slug)}`,
          {
            method: "GET",
            headers: {
              "Accept": "application/json",
              "ngrok-skip-browser-warning": "true"
            }
          }
        );

        if (!response.ok) {
          return null;
        }

        const data = await response.json();

        if (
          !data?.found ||
          !data?.campaign ||
          typeof data.campaign !== "object"
        ) {
          return null;
        }

        return {
          campaign: data.campaign,
          variants: {
            hero: data?.variants?.hero || null,
            promo: data?.variants?.promo || null,
            shop_more: data?.variants?.shop_more || null
          }
        };
      } catch (error) {
        console.error(
          "[HN Analytics] Campaign resolve error:",
          error
        );
        return null;
      }
    }

    async loadCampaign() {
      const urlSlug =
        this.getCampaignSlugFromUrl();

      const storedSlug =
        this.getStoredCampaignSlug();

      const slug =
        urlSlug || storedSlug;

      if (!slug) {
        this.activeCampaign = null;
        this.activeVariants = {
          hero: null,
          promo: null,
          shop_more: null
        };
        return null;
      }

      const resolved =
        await this.resolveCampaign(slug);

      if (!resolved) {
        if (
          urlSlug &&
          storedSlug &&
          urlSlug !== storedSlug
        ) {
          const storedResolved =
            await this.resolveCampaign(storedSlug);

          if (storedResolved) {
            this.activeCampaign =
              storedResolved.campaign;
            this.activeVariants =
              storedResolved.variants;
            return this.activeCampaign;
          }
        }

        this.activeCampaign = null;
        this.activeVariants = {
          hero: null,
          promo: null,
          shop_more: null
        };
        return null;
      }

      this.activeCampaign =
        resolved.campaign;
      this.activeVariants =
        resolved.variants;

      if (
        this.hasPersonalizationConsent()
      ) {
        this.storeCampaignSlug(
          this.activeCampaign.slug || slug
        );
      }

      return this.activeCampaign;
    }

    getCampaignExperience(
      fallbackExperience =
        "default"
    ) {
      const experience =
        this.activeCampaign
          ?.experience;

      return (
        typeof experience ===
          "string" &&
        experience.trim()
      )
        ? experience.trim()
        : fallbackExperience;
    }

    /* ============================================================
       TRACKING
    ============================================================ */

    async track(
      eventType,
      payload = {}
    ) {
      if (
        !this.hasPersonalizationConsent() ||
        !this.visitorId
      ) {
        

        return null;
      }

      const event = {
        visitor_id:
          this.visitorId,

        event_type:
          eventType,

        payload,

        url:
          window.location.href,

        timestamp:
          Date.now()
      };

      try {
        const response =
          await fetch(
            `${HN_API_URL}/api/events`,
            {
              method:
                "POST",

              headers: {
                "Content-Type":
                  "application/json",

                "ngrok-skip-browser-warning":
                  "true"
              },

              body:
                JSON.stringify(
                  event
                )
            }
          );

        if (!response.ok) {
          throw new Error(
            `HN API error: ${response.status}`
          );
        }

        const data =
          await response.json();

        

        return data;
      } catch (error) {
        

        return null;
      }
    }

    /* ============================================================
       PERSONALIZATION API
    ============================================================ */

    async personalize() {
      if (
        !this.hasPersonalizationConsent() ||
        !this.visitorId
      ) {
        return {
          experience:
            "default",

          profile:
            {},

          products:
            [],

          slots:
            {}
        };
      }

      try {
        const response =
          await fetch(
            `${HN_API_URL}/api/personalization/${this.visitorId}`,
            {
              method:
                "GET",

              headers: {
                "ngrok-skip-browser-warning":
                  "true"
              }
            }
          );

        if (!response.ok) {
          throw new Error(
            `HN personalization error: ${response.status}`
          );
        }

        const data =
          await response.json();

        

        return data;
      } catch (error) {
        

        return {
          experience:
            "default",

          profile:
            {},

          products:
            [],

          slots:
            {}
        };
      }
    }

    /* ============================================================
       RECOMMENDATIONS API
    ============================================================ */

    async getRecommendations(
      limit = 24
    ) {
      if (
        !this.hasPersonalizationConsent() ||
        !this.visitorId
      ) {
        return [];
      }

      try {
        const response =
          await fetch(
            `${HN_API_URL}/api/recommendations/${this.visitorId}?limit=${limit}`,
            {
              method:
                "GET",

              headers: {
                "ngrok-skip-browser-warning":
                  "true"
              }
            }
          );

        if (!response.ok) {
          throw new Error(
            `HN recommendations error: ${response.status}`
          );
        }

        const data =
          await response.json();

        const recommendations =
          Array.isArray(
            data?.recommendations
          )
            ? data.recommendations
            : [];

        

        return recommendations;
      } catch (error) {
        

        return [];
      }
    }

    /* ============================================================
       PRODUCT PAGE TRACKING
    ============================================================ */

    getShopifyProductHandle() {
      const match =
        window.location.pathname.match(
          /\/products\/([^/?#]+)/
        );

      if (!match) {
        return null;
      }

      return decodeURIComponent(
        match[1]
      );
    }

    async trackCurrentProduct() {
      const productId =
        this.getShopifyProductHandle();

      if (!productId) {
        return;
      }

      

      await this.track(
        "product_view",
        {
          product_id:
            productId
        }
      );
    }

    /* ============================================================
       PAGE HELPERS
    ============================================================ */

    isHomepage() {
      const path =
        window.location.pathname;

      return (
        path === "/" ||
        path === "/fr" ||
        path === "/fr/" ||
        path === ""
      );
    }

    isFrench() {
      return (
        document.documentElement
          .lang
          ?.toLowerCase()
          .startsWith("fr")
      );
    }

    /* ============================================================
       SHOPIFY PRODUCT API
    ============================================================ */

    async getShopifyProduct(
      handle
    ) {
      try {
        const response =
          await fetch(
            `/products/${encodeURIComponent(handle)}.js`,
            {
              method:
                "GET",

              headers: {
                Accept:
                  "application/json"
              }
            }
          );

        if (!response.ok) {
          throw new Error(
            `Shopify product error: ${response.status}`
          );
        }

        return await response.json();
      } catch (error) {
        

        return null;
      }
    }

    async getShopifyProducts(
      handles
    ) {
      if (
        !Array.isArray(handles)
      ) {
        return [];
      }

      const uniqueHandles =
        [
          ...new Set(
            handles.filter(Boolean)
          )
        ];

      const products =
        await Promise.all(
          uniqueHandles.map(
            handle =>
              this.getShopifyProduct(
                handle
              )
          )
        );

      /*
       * Stock LIVE Shopify.
       *
       * Un produit sans aucune
       * variante disponible est retiré.
       */

      return products.filter(
        product => {
          if (!product) {
            return false;
          }

          if (
            !Array.isArray(
              product.variants
            ) ||
            !product.variants.length
          ) {
            return false;
          }

          return product.variants.some(
            variant =>
              variant.available ===
              true
          );
        }
      );
    }

    /* ============================================================
       PRODUCT HELPERS
    ============================================================ */

    getProductVariant(
      product
    ) {
      if (
        !product ||
        !Array.isArray(
          product.variants
        )
      ) {
        return null;
      }

      return (
        product.variants.find(
          variant =>
            variant.available ===
            true
        ) || null
      );
    }

    getProductImage(
      product
    ) {
      if (
        typeof product
          ?.featured_image ===
        "string"
      ) {
        return product
          .featured_image;
      }

      if (
        product
          ?.featured_image
          ?.src
      ) {
        return product
          .featured_image
          .src;
      }

      if (
        Array.isArray(
          product?.images
        ) &&
        product.images.length
      ) {
        const image =
          product.images[0];

        return (
          typeof image ===
            "string"
            ? image
            : image?.src || ""
        );
      }

      return "";
    }

    formatMoney(
      cents
    ) {
      const value =
        Number(cents) / 100;

      const locale =
        this.isFrench()
          ? "fr-CA"
          : "en-CA";

      try {
        return new Intl
          .NumberFormat(
            locale,
            {
              style:
                "currency",

              currency:
                "CAD"
            }
          )
          .format(
            value
          );
      } catch (error) {
        return `$${value.toFixed(2)}`;
      }
    }

    escapeHtml(
      value
    ) {
      const div =
        document.createElement(
          "div"
        );

      div.textContent =
        value ?? "";

      return div.innerHTML;
    }

    /* ============================================================
       STANDARD PRODUCT CARD
    ============================================================ */

    buildProductCard(
      product
    ) {
      const variant =
        this.getProductVariant(
          product
        );

      if (!variant) {
        return "";
      }

      const image =
        this.getProductImage(
          product
        );

      const title =
        this.escapeHtml(
          product.title
        );

      const handle =
        this.escapeHtml(
          product.handle
        );

      const price =
        this.formatMoney(
          variant.price
        );

      const buttonText =
        this.isFrench()
          ? "Ajouter au panier"
          : "Add to cart";

      return `
        <div
          class="
            product-item
            product-item--vertical
            1/4--lap
            1/5--desk
            1/6--wide
          "
          data-hn-product="${handle}"
        >

          <a
            href="/products/${handle}"
            class="product-item__image-wrapper"
          >

            <div class="aspect-ratio">

              ${
                image
                  ? `
                    <img
                      src="${this.escapeHtml(image)}"
                      alt="${title}"
                      loading="lazy"
                    >
                  `
                  : ""
              }

            </div>

          </a>

          <div
            class="product-item__info"
          >

            <div
              class="product-item__info-inner"
            >

              <a
                href="/products/${handle}"
                class="product-item__title text--strong link"
              >
                ${title}
              </a>

              <div
                class="product-item__price-list price-list"
              >

                <span class="price">
                  ${price}
                </span>

              </div>

            </div>

            <button
              type="button"
              class="
                product-item__action-button
                button
                button--small
                button--primary
              "
              data-hn-add-to-cart="${variant.id}"
            >
              ${buttonText}
            </button>

          </div>

        </div>
      `;
    }

    /* ============================================================
       RECOMMENDATION CARD
    ============================================================ */

    buildRecommendationCard(
      product
    ) {
      const variant =
        this.getProductVariant(
          product
        );

      if (!variant) {
        return "";
      }

      const image =
        this.getProductImage(
          product
        );

      const title =
        this.escapeHtml(
          product.title
        );

      const handle =
        this.escapeHtml(
          product.handle
        );

      const priceValue =
        Number(
          variant.price
        );

      const compareValue =
        Number(
          variant.compare_at_price ||
          0
        );

      const price =
        this.formatMoney(
          priceValue
        );

      let compareHtml = "";
      let badgeHtml = "";

      if (
        compareValue >
        priceValue
      ) {
        const discount =
          Math.round(
            (
              (
                compareValue -
                priceValue
              ) /
              compareValue
            ) *
            100
          );

        compareHtml = `
          <s class="price--compare">
            ${this.formatMoney(
              compareValue
            )}
          </s>
        `;

        badgeHtml = `
          <div class="sale-badge">

            <span
              class="sale-badge__label"
            >
              ${
                this.isFrench()
                  ? "PROMO"
                  : "SALE"
              }
            </span>

            <strong
              class="sale-badge__discount"
            >
              -${discount}%
            </strong>

          </div>
        `;
      }

      const buttonText =
        this.isFrench()
          ? "Ajouter au panier"
          : "Add to cart";

      return `
        <div
          class="sale-collection__item"
          data-hn-recommendation-item
          data-hn-product-handle="${handle}"
        >

          ${badgeHtml}

          <div
            class="
              product-item
              product-item--vertical
            "
            data-hn-product="${handle}"
          >

            <a
              href="/products/${handle}"
              class="product-item__image-wrapper"
            >

              <div
                class="aspect-ratio"
              >

                ${
                  image
                    ? `
                      <img
                        src="${this.escapeHtml(image)}"
                        alt="${title}"
                        loading="lazy"
                      >
                    `
                    : ""
                }

              </div>

            </a>

            <div
              class="product-item__info"
            >

              <div
                class="product-item__info-inner"
              >

                <a
                  href="/products/${handle}"
                  class="product-item__title text--strong link"
                >
                  ${title}
                </a>

                <div
                  class="product-item__price-list price-list"
                >

                  <span class="price">
                    ${price}
                  </span>

                  ${compareHtml}

                </div>

              </div>

              <button
                type="button"
                class="
                  product-item__action-button
                  button
                  button--small
                  button--primary
                "
                data-hn-add-to-cart="${variant.id}"
              >
                ${buttonText}
              </button>

            </div>

          </div>

        </div>
      `;
    }

    /* ============================================================
       ADD TO CART
    ============================================================ */

    async addToCart(
      variantId,
      button
    ) {
      if (!variantId) {
        return;
      }

      const originalText =
        button.textContent;

      button.disabled =
        true;

      try {
        const response =
          await fetch(
            "/cart/add.js",
            {
              method:
                "POST",

              headers: {
                "Content-Type":
                  "application/json",

                Accept:
                  "application/json"
              },

              body:
                JSON.stringify({
                  items: [
                    {
                      id:
                        Number(
                          variantId
                        ),

                      quantity:
                        1
                    }
                  ]
                })
            }
          );

        if (!response.ok) {
          throw new Error(
            `Cart error: ${response.status}`
          );
        }

        await this.track(
          "add_to_cart",
          {
            variant_id:
              String(
                variantId
              )
          }
        );

        button.textContent =
          this.isFrench()
            ? "Ajouté"
            : "Added";

        document.dispatchEvent(
          new CustomEvent(
            "cart:refresh"
          )
        );

        document.dispatchEvent(
          new CustomEvent(
            "theme:cart:reload"
          )
        );
      } catch (error) {
        

        button.textContent =
          originalText;
      } finally {
        setTimeout(
          () => {
            button.disabled =
              false;

            button.textContent =
              originalText;
          },
          1500
        );
      }
    }

    bindAddToCart(
      section
    ) {
      const buttons =
        section.querySelectorAll(
          "[data-hn-add-to-cart]"
        );

      buttons.forEach(
        button => {
          if (
            button.dataset
              .hnBound ===
            "true"
          ) {
            return;
          }

          button.dataset
            .hnBound =
            "true";

          button.addEventListener(
            "click",
            async () => {
              await this.addToCart(
                button.dataset
                  .hnAddToCart,

                button
              );
            }
          );
        }
      );
    }

    /* ============================================================
       GLOBAL RECOMMENDATIONS
       TOUT LE CATALOGUE
    ============================================================ */

    async applyRecommendations() {
      const sections =
        document.querySelectorAll(
          "[data-hn-recommendations]"
        );

      if (!sections.length) {
        return;
      }

      /*
       * 24 meilleurs candidats selon HN.
       *
       * On en demande plus que nécessaire
       * pour pouvoir retirer les produits
       * sold out.
       */

      const recommendations =
        await this.getRecommendations(
          24
        );

      if (
        !recommendations.length
      ) {
        

        return;
      }

      const handles =
        recommendations
          .map(
            recommendation =>
              recommendation.handle
          )
          .filter(Boolean);

      const availableProducts =
        await this.getShopifyProducts(
          handles
        );

      if (
        !availableProducts.length
      ) {
        

        return;
      }

      /*
       * getShopifyProducts conserve
       * l'ordre des handles.
       *
       * Donc le ranking backend
       * reste intact.
       */

      sections.forEach(
        section => {
          const grid =
            section.querySelector(
              "[data-hn-recommendations-grid]"
            );

          if (!grid) {
            return;
          }

          const count =
            Number(
              section.dataset
                .hnProductsCount
            ) || 8;

          const selected =
            availableProducts.slice(
              0,
              count
            );

          const html =
            selected
              .map(
                product =>
                  this.buildRecommendationCard(
                    product
                  )
              )
              .filter(Boolean)
              .join("");

          if (!html) {
            return;
          }

          grid.innerHTML =
            html;

          this.bindAddToCart(
            section
          );

          section.dataset
            .hnActive =
            "true";

          
        }
      );
    }

    /* ============================================================
       SHOP PAGE HERO
    ============================================================ */

    applyShopHeroExperience(experience) {
      const hero = document.querySelector(
        "[data-hn-shop-hero]"
      );

      if (!hero || experience === "default") {
        return;
      }

      const eyebrow = hero.querySelector(
        "[data-hn-shop-hero-eyebrow]"
      );
      const title = hero.querySelector(
        "[data-hn-shop-hero-title]"
      );
      const description = hero.querySelector(
        "[data-hn-shop-hero-description]"
      );

      const content = this.isFrench()
        ? {
            business: {
              eyebrow: "POUR TRAVAILLER EFFICACEMENT",
              title: "Le bon équipement.<em>Pour travailler mieux.</em>",
              description:
                "Ordinateurs, écrans et équipements professionnels réunis pour bâtir un espace de travail fiable et efficace."
            },
            gaming: {
              eyebrow: "GAMING ET PERFORMANCE",
              title: "Plus de performance.<em>Pour mieux jouer.</em>",
              description:
                "Découvrez nos ordinateurs, composants et accessoires gaming conçus pour pousser votre expérience plus loin."
            },
            gaming_laptop: {
              eyebrow: "PORTABLES GAMING",
              title: "La puissance gaming.<em>Partout avec vous.</em>",
              description:
                "Explorez des portables gaming performants pour jouer, créer et travailler sans rester attaché à votre bureau."
            },
            components: {
              eyebrow: "COMPOSANTS ET PERFORMANCE PC",
              title: "Bâtissez plus vite.<em>Poussez plus loin.</em>",
              description:
                "Cartes graphiques, processeurs et composants sélectionnés pour améliorer ou construire votre prochaine machine."
            },
            apple: {
              eyebrow: "L’UNIVERS APPLE",
              title: "Vos essentiels Apple.<em>Au même endroit.</em>",
              description:
                "Découvrez nos appareils et accessoires Apple, accompagnés du service et des conseils de notre équipe locale."
            },
            printing: {
              eyebrow: "IMPRESSION",
              title: "Imprimez mieux.<em>Sans complications.</em>",
              description:
                "Trouvez l’imprimante, les fournitures et les solutions adaptées à votre maison ou à votre entreprise."
            },
            accessories: {
              eyebrow: "ACCESSOIRES ET PÉRIPHÉRIQUES",
              title: "Les bons accessoires.<em>Pour tout compléter.</em>",
              description:
                "Câbles, adaptateurs, claviers, souris et périphériques pour compléter votre installation simplement."
            }
          }
        : {
            business: {
              eyebrow: "BUILT FOR PRODUCTIVITY",
              title: "The right equipment.<em>For better work.</em>",
              description:
                "Computers, displays and professional equipment brought together for a reliable and efficient workspace."
            },
            gaming: {
              eyebrow: "GAMING AND PERFORMANCE",
              title: "More performance.<em>Better gaming.</em>",
              description:
                "Discover gaming computers, components and accessories designed to push your experience further."
            },
            gaming_laptop: {
              eyebrow: "GAMING LAPTOPS",
              title: "Gaming power.<em>Wherever you go.</em>",
              description:
                "Explore powerful gaming laptops made for gaming, creating and working beyond your desk."
            },
            components: {
              eyebrow: "PC COMPONENTS AND PERFORMANCE",
              title: "Build faster.<em>Push further.</em>",
              description:
                "Graphics cards, processors and components for upgrading or building your next machine."
            },
            apple: {
              eyebrow: "THE APPLE EXPERIENCE",
              title: "Your Apple essentials.<em>All in one place.</em>",
              description:
                "Discover Apple devices and accessories backed by service and advice from our local team."
            },
            printing: {
              eyebrow: "PRINTING",
              title: "Print better.<em>Without complications.</em>",
              description:
                "Find the printer, supplies and solutions suited to your home or business."
            },
            accessories: {
              eyebrow: "ACCESSORIES AND PERIPHERALS",
              title: "The right accessories.<em>To complete your setup.</em>",
              description:
                "Cables, adapters, keyboards, mice and peripherals to complete your setup with ease."
            }
          };

      const selected = content[experience];

      if (!selected) {
        return;
      }

      if (eyebrow) {
        eyebrow.textContent = selected.eyebrow;
      }

      if (title) {
        title.innerHTML = selected.title;
      }

      if (description) {
        description.textContent = selected.description;
      }

      hero.dataset.hnShopHeroExperience = experience;

      
    }

    /* ============================================================
       COMPLETE CATALOG INTEREST SCORING
    ============================================================ */

    getCatalogInterestScore(experience, metadata) {
      const keywordGroups = {
        business: [
          "business", "professionnel", "professional", "workstation",
          "bureau", "office", "productivity", "productivité", "thinkpad",
          "thinkcentre", "elitebook", "probook", "latitude", "optiplex",
          "monitor", "moniteur", "dock", "docking", "webcam", "conference"
        ],
        gaming: [
          "gaming", "gamer", "geforce", "rtx", "radeon", "graphics",
          "graphique", "gpu", "processor", "processeur", "cpu", "ryzen",
          "intel core", "motherboard", "carte mère", "ram", "memory",
          "mémoire", "ddr", "ssd", "nvme", "cooling", "refroidissement",
          "aio", "liquid cooler", "case", "boîtier", "power supply", "psu",
          "keyboard", "clavier", "mouse", "souris", "headset", "casque",
          "monitor", "moniteur", "high refresh", "hz"
        ],
        gaming_laptop: [
          "gaming laptop", "portable gaming", "gaming notebook", "rog",
          "tuf", "predator", "legion", "alienware", "omen", "victus",
          "msi", "geforce", "rtx", "radeon", "high refresh", "144hz",
          "165hz", "240hz"
        ],
        components: [
          "component", "composant", "graphics", "graphique", "geforce",
          "rtx", "radeon", "gpu", "processor", "processeur", "cpu", "ryzen",
          "intel core", "motherboard", "carte mère", "ram", "memory",
          "mémoire", "ddr", "ssd", "nvme", "hard drive", "disque dur",
          "cooling", "refroidissement", "aio", "fan", "ventilateur", "case",
          "boîtier", "power supply", "alimentation", "psu", "thermal"
        ],
        apple: [
          "apple", "mac", "macbook", "imac", "mac mini", "ipad", "iphone",
          "airpods", "magic keyboard", "magic mouse", "lightning", "magsafe",
          "thunderbolt"
        ],
        printing: [
          "printer", "imprimante", "printing", "impression", "laserjet",
          "deskjet", "officejet", "ecotank", "ink", "encre", "toner",
          "cartridge", "cartouche", "drum", "tambour", "brother", "epson",
          "canon"
        ],
        accessories: [
          "accessory", "accessoire", "cable", "câble", "adapter", "adaptateur",
          "keyboard", "clavier", "mouse", "souris", "headset", "casque",
          "webcam", "microphone", "dock", "hub", "charger", "chargeur",
          "usb", "hdmi", "displayport", "thunderbolt", "ethernet", "sleeve",
          "étui", "case", "stand", "support", "controller", "manette"
        ]
      };

      const keywords = experience === "gaming_laptop"
        ? [
            ...keywordGroups.gaming,
            ...keywordGroups.gaming_laptop
          ]
        : keywordGroups[experience] || [];

      if (!keywords.length) {
        return 0;
      }

      const title = metadata.title || "";
      const type = metadata.type || "";
      const vendor = metadata.vendor || "";
      const tags = metadata.tags || "";
      let score = 0;

      keywords.forEach(keyword => {
        if (title.includes(keyword)) {
          score += 12;
        }

        if (type.includes(keyword)) {
          score += 8;
        }

        if (tags.includes(keyword)) {
          score += 5;
        }

        if (vendor.includes(keyword)) {
          score += 4;
        }
      });

      return score;
    }

    /* ============================================================
       FULL PERSONALIZED CATALOG
       Keeps the original Liquid cards and 24 products per page.
    ============================================================ */

    async personalizeCatalog() {
      const grid = document.querySelector("[data-hn-catalog-grid]");

      if (!grid || !this.hasPersonalizationConsent()) {
        return;
      }

      const params = new URLSearchParams(window.location.search);

      const currentPage = Math.max(
        1,
        Number(grid.dataset.hnCurrentPage || params.get("page") || 1)
      );
      const totalPages = Math.max(1, Number(grid.dataset.hnTotalPages || 1));
      const totalProducts = Math.max(24, Number(grid.dataset.hnTotalProducts || 24));

      const personalization = await this.personalize();
      const profile =
        personalization?.profile && typeof personalization.profile === "object"
          ? personalization.profile
          : {};
      const profileExperience = this.getExperienceFromProfile(
        profile,
        personalization?.experience || "default"
      );

      const experience =
        this.getCampaignExperience(
          profileExperience
        );

      this.applyShopHeroExperience(
        experience
      );

      const recommendations = await this.getRecommendations(
        Math.min(totalProducts, 250)
      );
      const personalizedProducts = Array.isArray(personalization?.products)
        ? personalization.products
        : [];

      const normalizeHandle = value => {
        const raw = typeof value === "string"
          ? value
          : value?.handle || value?.product_id || "";

        return String(raw)
          .split("/products/")
          .pop()
          .split(/[?#]/)[0]
          .trim()
          .toLowerCase();
      };

      const rankedHandles = [
        ...recommendations.map(item => normalizeHandle(item)),
        ...personalizedProducts.map(item => normalizeHandle(item))
      ].filter(Boolean);

      const uniqueRankedHandles = [...new Set(rankedHandles)];

      const rank = new Map(
        uniqueRankedHandles.map((handle, index) => [handle, index])
      );
      const pageRequests = [];

      for (let page = 1; page <= totalPages; page += 1) {
        if (page === currentPage) {
          pageRequests.push(Promise.resolve(document));
          continue;
        }

        const pageUrl = new URL(window.location.href);
        pageUrl.searchParams.set("page", String(page));
        pageRequests.push(
          fetch(pageUrl.toString(), { headers: { Accept: "text/html" } })
            .then(response => {
              if (!response.ok) {
                throw new Error(`Catalog page error: ${response.status}`);
              }
              return response.text();
            })
            .then(html => new DOMParser().parseFromString(html, "text/html"))
        );
      }

      let pageDocuments;

      try {
        pageDocuments = await Promise.all(pageRequests);
      } catch (error) {
        
        return;
      }

      const seen = new Set();
      const cards = [];

      pageDocuments.forEach((pageDocument, pageIndex) => {
        const pageGrid = pageDocument.querySelector("[data-hn-catalog-grid]");

        if (!pageGrid) {
          return;
        }

        [...pageGrid.children].forEach((card, cardIndex) => {
          const handle = normalizeHandle(
            card.dataset.hnCatalogHandle || ""
          );

          if (!handle || seen.has(handle)) {
            return;
          }

          seen.add(handle);
          const metadata = {
            title: (card.dataset.hnCatalogTitle || "").toLowerCase(),
            type: (card.dataset.hnCatalogType || "").toLowerCase(),
            vendor: (card.dataset.hnCatalogVendor || "").toLowerCase(),
            tags: (card.dataset.hnCatalogTags || "").toLowerCase()
          };

          cards.push({
            card,
            handle,
            profileScore: this.getCatalogInterestScore(
              experience,
              metadata
            ),
            originalIndex: pageIndex * 24 + cardIndex
          });
        });
      });

      cards.sort((a, b) => {
        const rankA = rank.has(a.handle) ? rank.get(a.handle) : Number.MAX_SAFE_INTEGER;
        const rankB = rank.has(b.handle) ? rank.get(b.handle) : Number.MAX_SAFE_INTEGER;

        /* Tous les produits de la catégorie dominante passent avant
           les produits non reliés. Le ranking API départage ensuite
           les produits ayant un score de profil comparable. */
        return (
          b.profileScore - a.profileScore ||
          rankA - rankB ||
          a.originalIndex - b.originalIndex
        );
      });

      const start = (currentPage - 1) * 24;
      const visibleCards = cards.slice(start, start + 24);
      grid.replaceChildren(...visibleCards.map(item => item.card));
      grid.dataset.hnCatalogPersonalized = "true";

      const section = document.querySelector("[data-hn-catalog-message]");

      if (section) {
        const interests = this.isFrench()
          ? {
              business: "travail et productivité",
              gaming: "gaming et performance",
              gaming_laptop: "portables gaming",
              components: "composants et performance PC",
              apple: "produits Apple",
              printing: "impression",
              accessories: "accessoires et périphériques",
              default: "les catégories que vous consultez"
            }
          : {
              business: "work and productivity",
              gaming: "gaming and performance",
              gaming_laptop: "gaming laptops",
              components: "PC components and performance",
              apple: "Apple products",
              printing: "printing",
              accessories: "accessories and peripherals",
              default: "the categories you browse"
            };
        const interestNode = section.querySelector("[data-hn-catalog-interest]");

        if (interestNode) {
          interestNode.textContent = interests[experience] || interests.default;
        }

        section.hidden = false;
      }

      
    }

    /* ============================================================
       EXPERIENCE FROM FULL PROFILE
    ============================================================ */

    getExperienceFromProfile(
      profile,
      fallbackExperience =
        "default"
    ) {
      if (
        !profile ||
        typeof profile !==
          "object"
      ) {
        return fallbackExperience;
      }

      const interests = {
        business:
          Number(
            profile[
              "interest:business"
            ] || 0
          ),

        gaming:
          Number(
            profile[
              "interest:gaming"
            ] || 0
          ),

        components:
          Number(
            profile[
              "interest:components"
            ] || 0
          ),

        apple:
          Number(
            profile[
              "interest:apple"
            ] || 0
          ),

        printing:
          Number(
            profile[
              "interest:printing"
            ] || 0
          ),

        accessories:
          Number(
            profile[
              "interest:accessories"
            ] || 0
          )
      };

      const entries =
        Object.entries(
          interests
        ).sort(
          (a, b) =>
            b[1] -
            a[1]
        );

      if (!entries.length) {
        return fallbackExperience;
      }

      const [
        dominantInterest,
        dominantScore
      ] =
        entries[0];

      if (
        dominantScore < 6
      ) {
        return fallbackExperience;
      }

      /*
       * Gaming laptop est
       * plus précis que gaming.
       */

      if (
        dominantInterest ===
          "gaming" &&
        Number(
          profile[
            "product:laptop"
          ] || 0
        ) >= 4
      ) {
        return "gaming_laptop";
      }

      return dominantInterest;
    }

    /* Alias pour compatibilité avec
       ton ancien code.
    */

    getHeroExperienceFromProfile(
      profile,
      fallbackExperience =
        "default"
    ) {
      return this.getExperienceFromProfile(
        profile,
        fallbackExperience
      );
    }

    /* ============================================================
       INTRO PERSONALIZATION
    ============================================================ */

    applyIntroExperience(
      experience
    ) {
      const intro =
        document.querySelector(
          "[data-hn-intro]"
        );

      if (!intro) {
        return;
      }

      const eyebrow =
        intro.querySelector(
          "[data-hn-intro-eyebrow]"
        );

      const title =
        intro.querySelector(
          "[data-hn-intro-title]"
        );

      const description =
        intro.querySelector(
          "[data-hn-intro-description]"
        );

      if (
        !eyebrow ||
        !title ||
        !description
      ) {
        return;
      }

      const lang =
        intro.dataset
          .hnLang === "fr"
          ? "fr"
          : "en";

      const content = {
        fr: {
          default: {
            eyebrow:
              "NOUVEAUTÉS",

            title:
              `Du nouveau vient<br><em>d'arriver.</em>`,

            description:
              "Découvrez les plus récents produits ajoutés à notre sélection, fraîchement disponibles chez Microtec."
          },

          business: {
            eyebrow:
              "POUR VOTRE TRAVAIL",

            title:
              `Pensé pour<br><em>votre quotidien.</em>`,

            description:
              "Découvrez une sélection de produits professionnels choisie selon ce qui semble le mieux correspondre à vos besoins."
          },

          gaming: {
            eyebrow:
              "SÉLECTION GAMING",

            title:
              `Prêt pour votre<br><em>prochaine partie.</em>`,

            description:
              "Découvrez une sélection gaming adaptée aux produits et aux catégories qui semblent le plus vous intéresser."
          },

          gaming_laptop: {
            eyebrow:
              "PORTABLES GAMING",

            title:
              `La performance,<br><em>où que vous soyez.</em>`,

            description:
              "Une sélection de portables gaming choisie selon votre intérêt pour la performance et le jeu sur PC."
          },

          apple: {
            eyebrow:
              "SÉLECTION APPLE",

            title:
              `L'écosystème Apple,<br><em>pour vous.</em>`,

            description:
              "Découvrez une sélection de produits Apple qui correspond davantage à ce que vous avez consulté."
          },

          components: {
            eyebrow:
              "COMPOSANTS PC",

            title:
              `Pour votre prochaine<br><em>configuration.</em>`,

            description:
              "Processeurs, cartes graphiques et composants sélectionnés selon ce qui semble le plus vous intéresser."
          },

          printing: {
            eyebrow:
              "IMPRESSION",

            title:
              `Tout pour imprimer,<br><em>selon vos besoins.</em>`,

            description:
              "Découvrez des imprimantes et solutions d'impression sélectionnées selon ce qui semble le plus vous intéresser."
          },

          accessories: {
            eyebrow:
              "ACCESSOIRES",

            title:
              `Les bons accessoires,<br><em>pour votre installation.</em>`,

            description:
              "Découvrez des câbles, adaptateurs et périphériques sélectionnés selon vos intérêts."
          }
        },

        en: {
          default: {
            eyebrow:
              "NEW ARRIVALS",

            title:
              `Something new just<br><em>arrived.</em>`,

            description:
              "Discover the latest products added to our selection, now available at Microtec."
          },

          business: {
            eyebrow:
              "FOR YOUR WORK",

            title:
              `Built for your<br><em>daily work.</em>`,

            description:
              "Discover a selection of professional products chosen based on what appears most relevant to your needs."
          },

          gaming: {
            eyebrow:
              "GAMING PICKS",

            title:
              `Ready for your<br><em>next game.</em>`,

            description:
              "Discover gaming products selected according to the categories and products that seem to interest you most."
          },

          gaming_laptop: {
            eyebrow:
              "GAMING LAPTOPS",

            title:
              `Performance,<br><em>wherever you go.</em>`,

            description:
              "A selection of gaming laptops chosen according to your interest in PC gaming and performance."
          },

          apple: {
            eyebrow:
              "APPLE PICKS",

            title:
              `The Apple ecosystem,<br><em>picked for you.</em>`,

            description:
              "Discover Apple products selected according to what you have shown the most interest in."
          },

          components: {
            eyebrow:
              "PC COMPONENTS",

            title:
              `For your next<br><em>build.</em>`,

            description:
              "Processors, graphics cards and PC components selected according to what appears most relevant to you."
          },

          printing: {
            eyebrow:
              "PRINTING",

            title:
              `Everything you need to print,<br><em>picked for you.</em>`,

            description:
              "Discover printers and printing solutions selected according to your interests."
          },

          accessories: {
            eyebrow:
              "ACCESSORIES",

            title:
              `The right accessories,<br><em>for your setup.</em>`,

            description:
              "Discover cables, adapters and peripherals selected according to your interests."
          }
        }
      };

      const selected =
        content[lang][experience] ||
        content[lang].default;

      eyebrow.textContent =
        selected.eyebrow;

      title.innerHTML =
        selected.title;

      description.textContent =
        selected.description;

      intro.dataset
        .hnActive =
        "true";

      
    }

    /* ============================================================
       PROMO INTRO PERSONALIZATION
       OUR PICKS FOR YOU
    ============================================================ */

    applyPromoIntroExperience(
      experience
    ) {
      const intro =
        document.querySelector(
          "[data-hn-promo-intro]"
        );

      if (!intro) {
        return;
      }

      const eyebrow =
        intro.querySelector(
          "[data-hn-promo-eyebrow]"
        );

      const title =
        intro.querySelector(
          "[data-hn-promo-title]"
        );

      const description =
        intro.querySelector(
          "[data-hn-promo-description]"
        );

      if (
        !eyebrow ||
        !title ||
        !description
      ) {
        return;
      }

      const lang =
        intro.dataset
          .hnLang === "fr"
          ? "fr"
          : "en";

      const content = {
        fr: {
          default: {
            eyebrow:
              "SÉLECTIONNÉ POUR VOUS",

            title:
              `Des choix pensés<br><em>pour vous.</em>`,

            description:
              "Une sélection personnalisée selon les produits, marques et catégories qui semblent le plus correspondre à vos intérêts."
          },

          business: {
            eyebrow:
              "NOS CHOIX POUR VOUS",

            title:
              `Pour votre travail.<br><em>Choisi pour vous.</em>`,

            description:
              "Ordinateurs, équipements et solutions professionnelles sélectionnés selon ce qui semble le mieux correspondre à vos besoins."
          },

          gaming: {
            eyebrow:
              "NOS CHOIX POUR VOUS",

            title:
              `Votre prochain setup<br><em>commence ici.</em>`,

            description:
              "Une sélection gaming personnalisée selon les produits, marques et catégories qui retiennent le plus votre attention."
          },

          gaming_laptop: {
            eyebrow:
              "NOS CHOIX POUR VOUS",

            title:
              `La performance<br><em>qui vous suit.</em>`,

            description:
              "Des portables gaming sélectionnés selon votre intérêt pour la performance, la mobilité et le jeu sur PC."
          },

          apple: {
            eyebrow:
              "NOS CHOIX POUR VOUS",

            title:
              `Apple, sélectionné<br><em>pour vous.</em>`,

            description:
              "Une sélection personnalisée de produits Apple basée sur les appareils, accessoires et catégories qui semblent le plus vous intéresser."
          },

          components: {
            eyebrow:
              "NOS CHOIX POUR VOUS",

            title:
              `Pour votre prochaine<br><em>configuration.</em>`,

            description:
              "Cartes graphiques, processeurs et composants sélectionnés selon les produits et marques qui correspondent le mieux à vos intérêts."
          },

          printing: {
            eyebrow:
              "NOS CHOIX POUR VOUS",

            title:
              `Pour vos besoins<br><em>d'impression.</em>`,

            description:
              "Des imprimantes et solutions d'impression sélectionnées selon les produits, marques et catégories que vous semblez consulter davantage."
          },

          accessories: {
            eyebrow:
              "NOS CHOIX POUR VOUS",

            title:
              `Les bons accessoires.<br><em>Pour votre setup.</em>`,

            description:
              "Câbles, adaptateurs et périphériques sélectionnés selon les accessoires et catégories qui correspondent le mieux à vos intérêts."
          }
        },

        en: {
          default: {
            eyebrow:
              "PICKED FOR YOU",

            title:
              `A selection made<br><em>for you.</em>`,

            description:
              "A personalized selection based on the products, brands and categories that appear to match your interests most."
          },

          business: {
            eyebrow:
              "OUR PICKS FOR YOU",

            title:
              `For your work.<br><em>Picked for you.</em>`,

            description:
              "Computers, equipment and professional solutions selected according to what appears most relevant to your needs."
          },

          gaming: {
            eyebrow:
              "OUR PICKS FOR YOU",

            title:
              `Your next gaming setup<br><em>starts here.</em>`,

            description:
              "A personalized gaming selection based on the products, brands and categories that appear to catch your attention most."
          },

          gaming_laptop: {
            eyebrow:
              "OUR PICKS FOR YOU",

            title:
              `Performance that<br><em>goes with you.</em>`,

            description:
              "Gaming laptops selected according to your interest in performance, mobility and PC gaming."
          },

          apple: {
            eyebrow:
              "OUR PICKS FOR YOU",

            title:
              `Apple picks,<br><em>made for you.</em>`,

            description:
              "A personalized Apple selection based on the devices, accessories and categories you appear to care about most."
          },

          components: {
            eyebrow:
              "OUR PICKS FOR YOU",

            title:
              `For your next<br><em>PC build.</em>`,

            description:
              "Graphics cards, processors and PC components selected according to the products and brands that best match your interests."
          },

          printing: {
            eyebrow:
              "OUR PICKS FOR YOU",

            title:
              `For your<br><em>printing needs.</em>`,

            description:
              "Printers and printing solutions selected according to the products, brands and categories you appear to browse most."
          },

          accessories: {
            eyebrow:
              "OUR PICKS FOR YOU",

            title:
              `The right accessories.<br><em>For your setup.</em>`,

            description:
              "Cables, adapters and peripherals selected according to the accessories and categories that best match your interests."
          }
        }
      };

      const selected =
        content[lang][experience] ||
        content[lang].default;

      eyebrow.textContent =
        selected.eyebrow;

      title.innerHTML =
        selected.title;

      description.textContent =
        selected.description;

      intro.dataset
        .hnActive =
        "true";

      intro.dataset
        .hnPromoExperience =
        experience;

      
    }

    /* ============================================================
       SHOP MORE PERSONALIZATION
       "EVERYTHING WE THINK YOU'LL LIKE"
    ============================================================ */

    applyShopMoreExperience(
      experience
    ) {
      const section =
        document.querySelector(
          "[data-hn-shopmore]"
        );

      if (!section) {
        return;
      }

      const eyebrow =
        section.querySelector(
          "[data-hn-shopmore-eyebrow]"
        );

      const title =
        section.querySelector(
          "[data-hn-shopmore-title]"
        );

      const description =
        section.querySelector(
          "[data-hn-shopmore-description]"
        );

      const button =
        section.querySelector(
          "[data-hn-shopmore-button]"
        );

      const link =
        section.querySelector(
          "[data-hn-shopmore-link]"
        );

      if (
        !eyebrow ||
        !title ||
        !description ||
        !button
      ) {
        return;
      }

      const lang =
        section.dataset
          .hnLang === "fr"
          ? "fr"
          : "en";

      const content = {
        fr: {
          default: {
            eyebrow:
              "POUR VOUS",

            title:
              "Tout ce qu’on pense que vous pourriez aimer.",

            description:
              "Les produits qui correspondent le mieux à vos intérêts passent en premier. Continuez ensuite avec le reste de notre catalogue.",

            button:
              "Explorer votre sélection"
          },

          business: {
            eyebrow:
              "POUR VOUS",

            title:
              "Tout ce qu’on pense utile pour votre travail.",

            description:
              "Nous priorisons les ordinateurs, équipements et produits professionnels qui correspondent le mieux à vos intérêts, puis le reste de notre catalogue.",

            button:
              "Explorer votre sélection"
          },

          gaming: {
            eyebrow:
              "POUR VOUS",

            title:
              "Tout ce qu’on pense que votre setup pourrait aimer.",

            description:
              "Gaming, performance et accessoires : les produits les plus proches de vos intérêts passent en premier, puis vient le reste du catalogue.",

            button:
              "Voir vos recommandations"
          },

          gaming_laptop: {
            eyebrow:
              "POUR VOUS",

            title:
              "Tout ce qu’on pense fait pour votre gaming.",

            description:
              "Les portables et produits gaming qui correspondent le mieux à vos intérêts passent en premier, suivis du reste de notre catalogue.",

            button:
              "Explorer votre sélection"
          },

          apple: {
            eyebrow:
              "POUR VOUS",

            title:
              "Tout ce qu’on pense que vous pourriez aimer.",

            description:
              "Les produits et accessoires Apple les plus proches de vos intérêts sont priorisés, puis vous pourrez découvrir tout le reste de notre catalogue.",

            button:
              "Explorer votre sélection"
          },

          components: {
            eyebrow:
              "POUR VOUS",

            title:
              "Tout pour votre prochaine configuration.",

            description:
              "Les composants qui semblent le mieux correspondre à votre profil passent en premier, suivis de tous nos autres produits.",

            button:
              "Voir les produits pour vous"
          },

          printing: {
            eyebrow:
              "POUR VOUS",

            title:
              "Tout ce qu’on pense utile pour vos besoins d’impression.",

            description:
              "Les imprimantes et produits d’impression qui correspondent le mieux à vos intérêts passent en premier, puis vient le reste de notre catalogue.",

            button:
              "Explorer votre sélection"
          },

          accessories: {
            eyebrow:
              "POUR VOUS",

            title:
              "Tout ce qu’on pense utile à votre setup.",

            description:
              "Les accessoires, câbles et périphériques les plus proches de vos intérêts passent en premier, suivis du reste de notre catalogue.",

            button:
              "Explorer votre sélection"
          }
        },

        en: {
          default: {
            eyebrow:
              "PICKED FOR YOU",

            title:
              "Everything we think you might like.",

            description:
              "Products that best match your interests come first, followed by everything else in our catalog.",

            button:
              "Explore your picks"
          },

          business: {
            eyebrow:
              "PICKED FOR YOU",

            title:
              "Everything we think could help your work.",

            description:
              "Computers, equipment and professional products that best match your interests come first, followed by the rest of our catalog.",

            button:
              "Explore your picks"
          },

          gaming: {
            eyebrow:
              "PICKED FOR YOU",

            title:
              "Everything we think your setup might like.",

            description:
              "Gaming, performance and accessories that best match your interests come first, followed by everything else in our catalog.",

            button:
              "Explore your recommendations"
          },

          gaming_laptop: {
            eyebrow:
              "PICKED FOR YOU",

            title:
              "Everything we think fits your gaming.",

            description:
              "Gaming laptops and products that best match your interests come first, followed by the rest of our catalog.",

            button:
              "Explore your picks"
          },

          apple: {
            eyebrow:
              "PICKED FOR YOU",

            title:
              "Everything we think you might like.",

            description:
              "Apple products and accessories closest to your interests come first, followed by everything else in our catalog.",

            button:
              "Explore your picks"
          },

          components: {
            eyebrow:
              "PICKED FOR YOU",

            title:
              "Everything for your next PC build.",

            description:
              "Components that best match your profile come first, followed by all our other products.",

            button:
              "Explore products for you"
          },

          printing: {
            eyebrow:
              "PICKED FOR YOU",

            title:
              "Everything we think fits your printing needs.",

            description:
              "Printers and printing products that best match your interests come first, followed by everything else in our catalog.",

            button:
              "Explore your picks"
          },

          accessories: {
            eyebrow:
              "PICKED FOR YOU",

            title:
              "Everything we think belongs in your setup.",

            description:
              "Accessories, cables and peripherals closest to your interests come first, followed by everything else in our catalog.",

            button:
              "Explore your picks"
          }
        }
      };

      const selected =
        content[lang][experience] ||
        content[lang].default;

      eyebrow.textContent =
        selected.eyebrow;

      title.textContent =
        selected.title;

      description.textContent =
        selected.description;

      button.textContent =
        selected.button;

      /*
       * On indique à /collections/all
       * que le visiteur vient depuis
       * l'expérience personnalisée.
       */

      if (link) {
        const baseUrl =
          lang === "fr"
            ? "/fr/collections/all"
            : "/collections/all";

        link.href =
          `${baseUrl}?hn=personalized`;
      }

      section.dataset
        .hnActive =
        "true";

      section.dataset
        .hnShopmoreExperience =
        experience;

      
    }

    /* ============================================================
       HERO PERSONALIZATION
    ============================================================ */

    applyHeroExperience(
      experience
    ) {
      const hero =
        document.querySelector(
          "[data-hn-hero]"
        );

      if (!hero) {
        return;
      }

      const adaptiveSlide =
        hero.querySelector(
          '[data-hn-hero-slide="adaptive"]'
        );

      if (!adaptiveSlide) {
        return;
      }

      const eyebrow =
        adaptiveSlide.querySelector(
          "[data-hn-hero-eyebrow]"
        );

      const title =
        adaptiveSlide.querySelector(
          "[data-hn-hero-title]"
        );

      const description =
        adaptiveSlide.querySelector(
          "[data-hn-hero-description]"
        );

      const primary =
        adaptiveSlide.querySelector(
          "[data-hn-hero-primary]"
        );

      const primaryText =
        adaptiveSlide.querySelector(
          "[data-hn-hero-primary-text]"
        );

      const secondary =
        adaptiveSlide.querySelector(
          "[data-hn-hero-secondary]"
        );

      const secondaryText =
        adaptiveSlide.querySelector(
          "[data-hn-hero-secondary-text]"
        );

      const tabLabel =
        hero.querySelector(
          "[data-hn-hero-tab-label]"
        );

      const lang =
        hero.dataset.hnLang ===
          "fr"
          ? "fr"
          : "en";

      const content = {
        fr: {
          default: {
            eyebrow:
              "MICROTEC INFORMATIQUE · DRUMMONDVILLE",

            title:
              `Toute votre technologie.<br><em>Un seul partenaire.</em>`,

            description:
              "Magasin informatique, réparation, service Apple et solutions TI pour les entreprises.",

            primaryText:
              "Magasiner",

            primaryHref:
              "/fr/collections/all",

            secondaryText:
              "Découvrir nos services",

            secondaryHref:
              "#services",

            tabLabel:
              "Microtec",

            activeSlide:
              "business"
          },

          business: {
            eyebrow:
              "MICROTEC INFORMATIQUE · DRUMMONDVILLE",

            title:
              `Toute votre technologie.<br><em>Un seul partenaire.</em>`,

            description:
              "Magasin informatique, réparation, service Apple et solutions TI pour les entreprises.",

            primaryText:
              "Magasiner",

            primaryHref:
              "/fr/collections/all",

            secondaryText:
              "Découvrir nos services",

            secondaryHref:
              "#services",

            tabLabel:
              "Microtec",

            activeSlide:
              "business"
          },

          gaming: {
            eyebrow:
              "GAMING · PERFORMANCE PC",

            title:
              `Passez au niveau<br><em>supérieur.</em>`,

            description:
              "PC gaming, cartes graphiques, processeurs et accessoires sélectionnés selon ce qui semble le plus vous intéresser.",

            primaryText:
              "Voir le gaming",

            primaryHref:
              "/fr/collections/all",

            secondaryText:
              "Services aux entreprises",

            secondaryHref:
              "/fr/pages/entreprise",

            tabLabel:
              "Gaming",

            activeSlide:
              "adaptive"
          },

          gaming_laptop: {
            eyebrow:
              "PORTABLES GAMING",

            title:
              `La performance.<br><em>Partout avec vous.</em>`,

            description:
              "Découvrez des portables gaming pensés pour la performance et la mobilité.",

            primaryText:
              "Voir les portables",

            primaryHref:
              "/fr/collections/all",

            secondaryText:
              "Services aux entreprises",

            secondaryHref:
              "/fr/pages/entreprise",

            tabLabel:
              "Gaming",

            activeSlide:
              "adaptive"
          },

          apple: {
            eyebrow:
              "APPLE CHEZ MICROTEC",

            title:
              `L'écosystème Apple.<br><em>Près de chez vous.</em>`,

            description:
              "Découvrez nos produits Apple ainsi que l'accompagnement et les services Apple offerts par notre équipe locale.",

            primaryText:
              "Voir Apple",

            primaryHref:
              "/fr/collections/all",

            secondaryText:
              "Services aux entreprises",

            secondaryHref:
              "/fr/pages/entreprise",

            tabLabel:
              "Apple",

            activeSlide:
              "adaptive"
          },

          components: {
            eyebrow:
              "COMPOSANTS · PC BUILD",

            title:
              `Construisez votre<br><em>prochaine machine.</em>`,

            description:
              "Processeurs, cartes graphiques et composants PC sélectionnés selon les produits qui semblent le plus vous intéresser.",

            primaryText:
              "Voir les composants",

            primaryHref:
              "/fr/collections/all",

            secondaryText:
              "Services aux entreprises",

            secondaryHref:
              "/fr/pages/entreprise",

            tabLabel:
              "Composants",

            activeSlide:
              "adaptive"
          },

          printing: {
            eyebrow:
              "IMPRESSION & BUREAUTIQUE",

            title:
              `Tout pour imprimer.<br><em>Simplement.</em>`,

            description:
              "Imprimantes et solutions d'impression sélectionnées selon les produits qui semblent le plus vous intéresser.",

            primaryText:
              "Voir les imprimantes",

            primaryHref:
              "/fr/collections/all",

            secondaryText:
              "Services aux entreprises",

            secondaryHref:
              "/fr/pages/entreprise",

            tabLabel:
              "Impression",

            activeSlide:
              "adaptive"
          },

          accessories: {
            eyebrow:
              "ACCESSOIRES & CONNECTIVITÉ",

            title:
              `Les bons accessoires.<br><em>Pour votre installation.</em>`,

            description:
              "Câbles, adaptateurs, périphériques et accessoires sélectionnés selon vos intérêts.",

            primaryText:
              "Voir les accessoires",

            primaryHref:
              "/fr/collections/all",

            secondaryText:
              "Services aux entreprises",

            secondaryHref:
              "/fr/pages/entreprise",

            tabLabel:
              "Accessoires",

            activeSlide:
              "adaptive"
          }
        },

        en: {
          default: {
            eyebrow:
              "MICROTEC INFORMATIQUE · DRUMMONDVILLE",

            title:
              `Everything technology.<br><em>One trusted partner.</em>`,

            description:
              "Computer store, repairs, Apple service and business IT solutions.",

            primaryText:
              "Shop now",

            primaryHref:
              "/collections/all",

            secondaryText:
              "Explore our services",

            secondaryHref:
              "#services",

            tabLabel:
              "Microtec",

            activeSlide:
              "business"
          },

          business: {
            eyebrow:
              "MICROTEC INFORMATIQUE · DRUMMONDVILLE",

            title:
              `Everything technology.<br><em>One trusted partner.</em>`,

            description:
              "Computer store, repairs, Apple service and business IT solutions.",

            primaryText:
              "Shop now",

            primaryHref:
              "/collections/all",

            secondaryText:
              "Explore our services",

            secondaryHref:
              "#services",

            tabLabel:
              "Microtec",

            activeSlide:
              "business"
          },

          gaming: {
            eyebrow:
              "GAMING · PC PERFORMANCE",

            title:
              `Take your setup<br><em>to the next level.</em>`,

            description:
              "Gaming PCs, graphics cards, processors and accessories selected according to your interests.",

            primaryText:
              "Explore gaming",

            primaryHref:
              "/collections/all",

            secondaryText:
              "Business services",

            secondaryHref:
              "/pages/entreprise",

            tabLabel:
              "Gaming",

            activeSlide:
              "adaptive"
          },

          gaming_laptop: {
            eyebrow:
              "GAMING LAPTOPS",

            title:
              `Performance.<br><em>Wherever you go.</em>`,

            description:
              "Discover gaming laptops built for performance and mobility.",

            primaryText:
              "Explore laptops",

            primaryHref:
              "/collections/all",

            secondaryText:
              "Business services",

            secondaryHref:
              "/pages/entreprise",

            tabLabel:
              "Gaming",

            activeSlide:
              "adaptive"
          },

          apple: {
            eyebrow:
              "APPLE AT MICROTEC",

            title:
              `The Apple ecosystem.<br><em>Close to home.</em>`,

            description:
              "Discover Apple products along with support and Apple service from our local team.",

            primaryText:
              "Explore Apple",

            primaryHref:
              "/collections/all",

            secondaryText:
              "Business services",

            secondaryHref:
              "/pages/entreprise",

            tabLabel:
              "Apple",

            activeSlide:
              "adaptive"
          },

          components: {
            eyebrow:
              "COMPONENTS · PC BUILD",

            title:
              `Build your<br><em>next machine.</em>`,

            description:
              "Processors, graphics cards and PC components selected according to your interests.",

            primaryText:
              "Explore components",

            primaryHref:
              "/collections/all",

            secondaryText:
              "Business services",

            secondaryHref:
              "/pages/entreprise",

            tabLabel:
              "Components",

            activeSlide:
              "adaptive"
          },

          printing: {
            eyebrow:
              "PRINTING & OFFICE",

            title:
              `Everything you need to print.<br><em>Simply.</em>`,

            description:
              "Printers and printing solutions selected according to what appears most relevant to you.",

            primaryText:
              "Explore printers",

            primaryHref:
              "/collections/all",

            secondaryText:
              "Business services",

            secondaryHref:
              "/pages/entreprise",

            tabLabel:
              "Printing",

            activeSlide:
              "adaptive"
          },

          accessories: {
            eyebrow:
              "ACCESSORIES & CONNECTIVITY",

            title:
              `The right accessories.<br><em>For your setup.</em>`,

            description:
              "Cables, adapters, peripherals and accessories selected according to your interests.",

            primaryText:
              "Explore accessories",

            primaryHref:
              "/collections/all",

            secondaryText:
              "Business services",

            secondaryHref:
              "/pages/entreprise",

            tabLabel:
              "Accessories",

            activeSlide:
              "adaptive"
          }
        }
      };

      const selected =
        content[lang][experience] ||
        content[lang].default;

      if (eyebrow) {
        eyebrow.textContent =
          selected.eyebrow;
      }

      if (title) {
        title.innerHTML =
          selected.title;
      }

      if (description) {
        description.textContent =
          selected.description;
      }

      if (primaryText) {
        primaryText.textContent =
          selected.primaryText;
      }

      if (primary) {
        primary.href =
          selected.primaryHref;
      }

      if (secondaryText) {
        secondaryText.textContent =
          selected.secondaryText;
      }

      if (secondary) {
        secondary.href =
          selected.secondaryHref;
      }

      if (tabLabel) {
        tabLabel.textContent =
          selected.tabLabel;
      }

      hero.dispatchEvent(
        new CustomEvent(
          "hn:hero-activate",
          {
            detail: {
              slide:
                selected.activeSlide
            }
          }
        )
      );

      hero.dataset
        .hnHeroExperience =
        experience;

      
    }

    /* ============================================================
       MAIN PRODUCT EXPERIENCE
    ============================================================ */

    async applyProductExperience(
      experience,
      handles
    ) {
      if (
        experience ===
        "default"
      ) {
        return;
      }

      if (
        !Array.isArray(
          handles
        ) ||
        !handles.length
      ) {
        return;
      }

      const sections =
        document.querySelectorAll(
          "[data-hn-product-personalization]"
        );

      if (!sections.length) {
        return;
      }

      const products =
        await this.getShopifyProducts(
          handles
        );

      if (!products.length) {
        return;
      }

      sections.forEach(
        section => {
          const list =
            section.querySelector(
              ".product-list"
            );

          if (!list) {
            return;
          }

          const count =
            Number(
              section.dataset
                .hnProductsCount
            ) || 6;

          const selected =
            products.slice(
              0,
              count
            );

          const html =
            selected
              .map(
                product =>
                  this.buildProductCard(
                    product
                  )
              )
              .filter(Boolean)
              .join("");

          if (!html) {
            return;
          }

          list.innerHTML =
            html;

          this.bindAddToCart(
            section
          );

          section.dataset
            .hnActiveExperience =
            experience;

          
        }
      );
    }

    /* ============================================================
       CAMPAIGN CONTENT FROM API / POSTGRESQL
    ============================================================ */

    applyCampaignHeroVariant() {
      const variant = this.activeVariants?.hero;
      const content = variant?.content;

      if (!content || typeof content !== "object") {
        return false;
      }

      const hero = document.querySelector("[data-hn-hero]");
      if (!hero) return false;

      const target =
        hero.querySelector('[data-hn-hero-slide="adaptive"]') || hero;

      const eyebrow = target.querySelector("[data-hn-hero-eyebrow]");
      const title = target.querySelector("[data-hn-hero-title]");
      const description = target.querySelector("[data-hn-hero-description]");
      const primary = target.querySelector("[data-hn-hero-primary]");
      const primaryText = target.querySelector("[data-hn-hero-primary-text]");
      const secondary = target.querySelector("[data-hn-hero-secondary]");
      const secondaryText = target.querySelector("[data-hn-hero-secondary-text]");
      const tabLabel = hero.querySelector("[data-hn-hero-tab-label]");

      if (eyebrow && typeof content.eyebrow === "string")
        eyebrow.textContent = content.eyebrow;
      if (title && typeof content.title === "string")
        title.innerHTML = content.title;
      if (description && typeof content.description === "string")
        description.textContent = content.description;

      const primaryLabel = content.primary_text ?? content.primaryText ?? content.button_text;
      const primaryHref = content.primary_href ?? content.primaryHref ?? content.button_url;
      const secondaryLabel = content.secondary_text ?? content.secondaryText;
      const secondaryHref = content.secondary_href ?? content.secondaryHref;
      const tabText = content.tab_label ?? content.tabLabel;

      if (primaryText && typeof primaryLabel === "string")
        primaryText.textContent = primaryLabel;
      if (primary && typeof primaryHref === "string")
        primary.href = primaryHref;
      if (secondaryText && typeof secondaryLabel === "string")
        secondaryText.textContent = secondaryLabel;
      if (secondary && typeof secondaryHref === "string")
        secondary.href = secondaryHref;
      if (tabLabel && typeof tabText === "string")
        tabLabel.textContent = tabText;

      hero.dataset.hnCampaignVariant = variant.key || "campaign";
      return true;
    }

    applyCampaignPromoVariant() {
      const variant = this.activeVariants?.promo;
      const content = variant?.content;

      if (!content || typeof content !== "object") {
        return false;
      }

      const section = document.querySelector("[data-hn-promo-intro]");
      if (!section) return false;

      const eyebrow = section.querySelector("[data-hn-promo-eyebrow]");
      const title = section.querySelector("[data-hn-promo-title]");
      const description = section.querySelector("[data-hn-promo-description]");
      const button = section.querySelector("[data-hn-promo-button]");

      if (eyebrow && typeof content.eyebrow === "string")
        eyebrow.textContent = content.eyebrow;
      if (title && typeof content.title === "string")
        title.innerHTML = content.title;
      if (description && typeof content.description === "string")
        description.textContent = content.description;
      if (button && typeof content.button_text === "string")
        button.textContent = content.button_text;
      if (button && typeof content.button_url === "string")
        button.href = content.button_url;

      section.dataset.hnCampaignVariant = variant.key || "campaign";
      return true;
    }

    applyCampaignShopMoreVariant() {
      const variant = this.activeVariants?.shop_more;
      const content = variant?.content;

      if (!content || typeof content !== "object") {
        return false;
      }

      const section = document.querySelector("[data-hn-shopmore]");
      if (!section) return false;

      const eyebrow = section.querySelector("[data-hn-shopmore-eyebrow]");
      const title = section.querySelector("[data-hn-shopmore-title]");
      const description = section.querySelector("[data-hn-shopmore-description]");
      const button = section.querySelector("[data-hn-shopmore-button]");
      const link = section.querySelector("[data-hn-shopmore-link]");

      if (eyebrow && typeof content.eyebrow === "string")
        eyebrow.textContent = content.eyebrow;
      if (title && typeof content.title === "string")
        title.innerHTML = content.title;
      if (description && typeof content.description === "string")
        description.textContent = content.description;
      if (button && typeof content.button_text === "string")
        button.textContent = content.button_text;
      if (link && typeof content.button_url === "string")
        link.href = content.button_url;

      if (Array.isArray(content.collections)) {
        section.dataset.hnCollections = content.collections.join(",");
      }

      section.dataset.hnCampaignVariant = variant.key || "campaign";
      return true;
    }

    /* ============================================================
       HOMEPAGE PERSONALIZATION
    ============================================================ */

    async personalizeHomepage() {
      if (!this.isHomepage()) {
        return;
      }

      if (!this.hasPersonalizationConsent()) {
        return;
      }

      const data = await this.personalize();
      const experience = data?.experience || "default";
      const profile =
        data?.profile && typeof data.profile === "object"
          ? data.profile
          : {};
      const products = Array.isArray(data?.products)
        ? data.products
        : [];

      const profileExperience =
        this.getExperienceFromProfile(profile, experience);

      const finalExperience =
        this.getCampaignExperience(profileExperience);

      /* HERO : campagne DB en priorité, fallback HN historique. */
      const campaignHeroApplied =
        this.applyCampaignHeroVariant();
      if (!campaignHeroApplied) {
        this.applyHeroExperience(finalExperience);
      }

      /* INTRO / NOUVEAUTÉS : personnalisation HN normale. */
      this.applyIntroExperience(finalExperience);

      /* PROMO : campagne DB en priorité. */
      const campaignPromoApplied =
        this.applyCampaignPromoVariant();
      if (!campaignPromoApplied) {
        this.applyPromoIntroExperience(finalExperience);
      }

      /* SHOP MORE : campagne DB en priorité. */
      const campaignShopMoreApplied =
        this.applyCampaignShopMoreVariant();
      if (!campaignShopMoreApplied) {
        this.applyShopMoreExperience(finalExperience);
      }

      await this.applyProductExperience(
        finalExperience,
        products
      );

      await this.applyRecommendations();
    }
  }

  /* ============================================================
     INIT
  ============================================================ */

  window.HN =
    new HNAnalytics();

  

  document.addEventListener(
    "DOMContentLoaded",
    async function () {
      await window.HN
        .loadCampaign();

      await window.HN
        .trackCurrentProduct();

      await window.HN
        .personalizeCatalog();

      await window.HN
        .personalizeHomepage();
    }
  );
})();
